import type { FC } from 'react';

import { Avatar } from '../ui/Avatar';

import { useCommunityDisplayName } from '../../_hooks/useCommunityDisplayName';
import { useCommunityLogoUrl } from '../../_hooks/useCommunityLogoUrl';
import { NavSubtitle } from './NavSubtitle';

export const CommunityIdentity: FC = () => {
  const displayName = useCommunityDisplayName();
  const logoUrl = useCommunityLogoUrl();

  return (
    <div className="flex min-h-14 w-full min-w-0 items-center gap-3 text-community-text-on-bg">
      <Avatar src={logoUrl} alt={displayName} className="size-12" fallbackClassName="bg-gray-300" />
      <div className="flex min-w-0 flex-1 flex-col items-start gap-1">
        <span className="max-w-full truncate text-[15px] font-semibold leading-5 tracking-[-0.15px]">
          {displayName}
        </span>
        <NavSubtitle />
      </div>
    </div>
  );
};
